import { ICampaignMessage } from '@dataTypes/marketing.type'
import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from '../errors/api-error'

// Constants
const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_MARKETING', '')

const headers = {
  'Content-Type': 'application/json',
}

// Types
interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

type CampaignsMessageData = {
  campaign_messages?: ICampaignMessage[]
}

type GenericResponseData = Record<string, unknown>

type UpdateCampaignMessageResponse = ApiResponse<CampaignsMessageData>
type CreateCampaignMessageResponse = ApiResponse<GenericResponseData>
type CreateMultipleCampaignMessageResponse = ApiResponse<CampaignsMessageData>

// API Functions
export const updateCampaignMessageBySID = async (
  updatedData: Partial<ICampaignMessage>,
  campaign_message_id?: string,
  message_sid?: string,
): Promise<UpdateCampaignMessageResponse> => {
  try {
    const response = await axios.put<UpdateCampaignMessageResponse>(
      `${BUSINESS_LAYER_API}/api/v1/campaign/message`,
      { message_sid, campaign_message_id, data: updatedData },
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in updateCampaignMessageBySID:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const createCampaignMessage = async (
  messageDetails: ICampaignMessage,
): Promise<CreateCampaignMessageResponse> => {
  try {
    const response = await axios.post<CreateCampaignMessageResponse>(
      `${BUSINESS_LAYER_API}/api/v1/campaign/message`,
      messageDetails,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in createCampaignMessage:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const createMultipleCampaignMessages = async (
  messages: ICampaignMessage[],
): Promise<CreateMultipleCampaignMessageResponse> => {
  try {
    const response = await axios.post<CreateMultipleCampaignMessageResponse>(
      `${BUSINESS_LAYER_API}/api/v1/campaign/message/bulk`,
      { campaign_messages: messages },
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in createMultipleCampaignMessages:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const deleteCampaignMessageById = async (
  campaignMessageId: string,
): Promise<CreateCampaignMessageResponse> => {
  try {
    const response = await axios.delete<CreateCampaignMessageResponse>(
      `${BUSINESS_LAYER_API}/api/v1/campaign/message/${campaignMessageId}`,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in deleteCampaignMessageById:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}
